module.exports = __webpack_public_path__ + "static/img/cyberduck-icon-64.3dfc6c42.png";